<!-- End Navbar -->
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary" style="height: 3.75rem">
            <h4 class="card-title ">{{sociedad}}</h4>
          </div>

          <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
            [length]="totalItems" (page)="onPageChange($event)">
          </mat-paginator>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <th>ID. {{ 'texto_672' | translate }}</th>
                  <th>N. {{ 'texto_672' | translate }}</th>
                  <th>N. {{ 'texto_67' | translate }}</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of centros">
                    <td>{{ item.id_centro }}</td>
                    <td>{{ item.n_centro }}</td>
                    <td>{{ item.n_empresa }}</td>
                    <td class="td-actions text-right" style="width:90px;">
                      <button (click)="showCenter(item)" type="button" title="Edit Center"
                        style="background: none;color:black;border:none;">
                        <i class="material-icons">edit</i>
                      </button>
                      <button (click)="deleteCenter(item.id_centro)" type="button" title="Remove"
                        style="background: none;color:red;border:none;">
                        <i class="material-icons">clear</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Modal Edit -->
              <div [style.display]="IsHiddenForm ? 'block' : 'none'" class="modal"
                style="width: 100% !important; margin: 0 auto;" id="imagemodal" tabindex="-1" role="dialog">
                <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
                  <div class="modal-content" style="width: 100% !important;">
                    <div class="modal-body mx-3" style="width: 100% !important;">
                      <div class="card-header card-header-info">
                        <h5 class="card-title" style="margin-bottom: 0px;">{{ 'texto_686' | translate }}</h5>
                      </div>
                      <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
                        (click)="hideModal()" aria-label="Cerrar modal">X</button>

                      <div class="md-form mb-3">
                        <input type="text" class="form-control" [formControl]="signupFormModalId" mdbInput mdbValidate
                          readonly>
                        <label>ID. {{ 'texto_672' | translate }}</label>
                        <mdb-error
                          *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">{{
                          'texto_61' | translate }}</mdb-error>
                        <mdb-success
                          *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">{{
                          'texto_62' | translate }}</mdb-success>
                      </div>

                      <div class="md-form mb-3">
                        <input type="text" class="form-control" [formControl]="signupFormModalName" mdbInput
                          maxlength="255" mdbValidate>
                        <label>N. {{ 'texto_672' | translate }}</label>
                        <mdb-error
                          *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">{{
                          'texto_61' | translate }}</mdb-error>
                        <mdb-success
                          *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">{{
                          'texto_62' | translate }}</mdb-success>
                      </div>

                      <div class="md-form mb-3">
                        <label>ID. {{ 'texto_67' | translate }}</label><br>
                        <mat-form-field>
                          <mat-select [formControl]="signupFormModalidEmpresa">
                            <mat-option *ngFor="let empresa of empresas" [value]="empresa.id_empresa">{{
                              empresa.n_empresa }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mdb-error
                          *ngIf="signupFormModalidEmpresa.invalid && (signupFormModalidEmpresa.dirty || signupFormModalidEmpresa.touched)">{{
                          'texto_61' | translate }}</mdb-error>
                        <mdb-success
                          *ngIf="signupFormModalidEmpresa.valid && (signupFormModalidEmpresa.dirty || signupFormModalidEmpresa.touched)">{{
                          'texto_62' | translate }}</mdb-success>
                        <br>
                      </div>

                      <div class="md-form">
                        <mdb-icon fas icon="pencil-alt" class="prefix grey-text"></mdb-icon>
                        <textarea maxlength="4000" class="md-textarea form-control" rows="5" mdbInput
                          [formControl]="contactFormModalMessage"></textarea>
                        <label for="form107Modal">{{ 'texto_46' | translate }}</label>
                        <mdb-error
                          *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                          {{ 'texto_61' | translate }}
                        </mdb-error>
                        <mdb-success
                          *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                          {{ 'texto_62' | translate }}
                        </mdb-success>
                      </div>
                    </div>

                    <div class="text-center mt-3">
                      <button (click)="updateCenter(signupFormModalId.value)" mdbBtn rounded="true"
                        class="btn-primary mt-1 waves-light" mdbWavesEffect>{{ 'texto_59' | translate }}</button>
                    </div>
                  </div>
                </div>
              </div>

              <app-add-center></app-add-center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
